import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import map from 'lodash/map';
import size from 'lodash/size';

import styles from './Menu.module.css';

const MenuItem = ({
  id,
  name,
  submenu,
  selected,
  checkSelected,
  onClickItem,
}) => {
  // eslint-disable-next-line eqeqeq
  const isSelected = selected == id;
  const [isExpanded, setIsExpanded] = useState(false);
  const toggle = () => setIsExpanded((prevState) => !prevState);

  return (
    <li value={id} key={id} className={styles.optionItem}>
      <div className={styles.buttons}>
        <button
          type="button"
          className={classNames(styles.optionButton, {
            [styles.selected]: isSelected,
          })}
          onClick={() => onClickItem(id, name)}
        >
          {name}
          {isSelected && checkSelected && <i className="far fa-check" />}
        </button>
        {size(submenu) ? (
          <button
            type="button"
            className={styles.expandButton}
            onClick={toggle}
          >
            {isExpanded ? (
              <i className="far fa-chevron-down" />
            ) : (
              <i className="far fa-chevron-right" />
            )}
          </button>
        ) : null}
      </div>
      {isExpanded && (
        <ul className={styles.children}>
          {map(submenu, (option) => {
            const { id: childId, name: childName } = option;
            // eslint-disable-next-line eqeqeq
            const isChildSelected = selected == childId;
            return (
              <li key={childId} className={styles.childItem}>
                <button
                  type="button"
                  className={classNames(styles.childButton, {
                    [styles.selected]: isChildSelected,
                  })}
                  onClick={() => onClickItem(childId, childName)}
                >
                  {childName}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};

MenuItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string.isRequired,
  submenu: PropTypes.arrayOf(PropTypes.shape()),
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  checkSelected: PropTypes.bool,
  onClickItem: PropTypes.func.isRequired,
};

MenuItem.defaultProps = {
  id: null,
  submenu: [],
  selected: null,
  checkSelected: false,
};

export default MenuItem;
